import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import axiosAuth from "@/services/axiosAuth";
import { PROPERTY_ZONE } from "./apiRoutes";

interface UseGetProps {
  communityId: string
  queryParams?: Omit<UseQueryOptions, "queryKey">
}

const getActivePropertyZones = async (communityId: string) =>
  await axiosAuth.get(`${PROPERTY_ZONE(communityId)}/active`);

const useGetActivePropertyZones = ({communityId, queryParams}: UseGetProps): UseQueryResult<any> => {
  return useQuery({
    queryKey: ["property-active-zones", communityId],
    queryFn: () => getActivePropertyZones(communityId),
    select: (data: any) => data.data,
    refetchOnWindowFocus: false,
    ...queryParams,
    enabled: !!communityId && (queryParams?.enabled ?? true),
  });
};

export default useGetActivePropertyZones;
